import { resolveNextSubpathAsync } from './next-subpath-resolve-hook'

export const resolve = resolveNextSubpathAsync
